sap.ui.requireSync("jquery.sap.strings");
